"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseReportingColumnDefinition_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EnterpriseReportingReport_1 = require("./EnterpriseReportingReport");
var EnterpriseReportingColumnDefinition_Factory = /** @class */ (function () {
    function EnterpriseReportingColumnDefinition_Factory() {
    }
    EnterpriseReportingColumnDefinition_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Report: EnterpriseReportingReport_1.EnterpriseReportingReport_Factory.CreateIncoming(model.Report),
            ReportId: model.ReportId,
        };
        return result;
    };
    EnterpriseReportingColumnDefinition_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Report: EnterpriseReportingReport_1.EnterpriseReportingReport_Factory.CreateOutgoing(model.Report),
            ReportId: model.ReportId,
        };
        return result;
    };
    return EnterpriseReportingColumnDefinition_Factory;
}());
exports.EnterpriseReportingColumnDefinition_Factory = EnterpriseReportingColumnDefinition_Factory;
